// ** Styled Component Import
import { Card } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

// ** Icon Imports
import { GuardWrapper } from 'src/layouts/GuardWrapper'
import { getAssignedPatients } from 'src/redux/patient/patient.action'
import { AssignedPatientTable } from 'src/views/patients/assignedPatientsTable'

const AssignedPatients = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAssignedPatients())
  }, [dispatch])

  return (
    <GuardWrapper {...props}>

      <Card>
        <AssignedPatientTable />
      </Card>
    </GuardWrapper>
  )
}

export default AssignedPatients
